<template>
    <g clip-path="url(#clip0_1104_2708)">
        <path
            d="M29.5165 57.5117H12.3785C11.4413 57.5117 10.6816 58.2714 10.6816 59.2086C10.6816 60.1457 11.4413 60.9054 12.3785 60.9054H29.5165C30.4536 60.9054 31.2133 60.1457 31.2133 59.2086C31.2133 58.2714 30.4536 57.5117 29.5165 57.5117Z"
            fill="#353CEE"
        />
        <path
            d="M55.1376 57.5117H37.9996C37.0624 57.5117 36.3027 58.2714 36.3027 59.2086C36.3027 60.1457 37.0624 60.9054 37.9996 60.9054H55.1376C56.0746 60.9054 56.8344 60.1457 56.8344 59.2086C56.8344 58.2714 56.0746 57.5117 55.1376 57.5117Z"
            fill="#353CEE"
        />
        <path
            d="M55.1387 15.0898H12.3785C11.4413 15.0898 10.6816 15.8495 10.6816 16.7867C10.6816 17.7238 11.4413 18.4835 12.3785 18.4835H55.1387C56.0756 18.4835 56.8355 17.7238 56.8355 16.7867C56.8355 15.8495 56.0756 15.0898 55.1387 15.0898Z"
            fill="#353CEE"
        />
        <path
            d="M55.1376 23.5742H37.9996C37.0624 23.5742 36.3027 24.3339 36.3027 25.2711C36.3027 26.2082 37.0624 26.9679 37.9996 26.9679H55.1376C56.0746 26.9679 56.8344 26.2082 56.8344 25.2711C56.8344 24.3339 56.0746 23.5742 55.1376 23.5742Z"
            fill="#353CEE"
        />
        <path
            d="M55.1376 32.0586H37.9996C37.0624 32.0586 36.3027 32.8183 36.3027 33.7554C36.3027 34.6926 37.0624 35.4523 37.9996 35.4523H55.1376C56.0746 35.4523 56.8344 34.6926 56.8344 33.7554C56.8344 32.8183 56.0746 32.0586 55.1376 32.0586Z"
            fill="#353CEE"
        />
        <path
            d="M55.1376 40.543H37.9996C37.0624 40.543 36.3027 41.3026 36.3027 42.2398C36.3027 43.177 37.0624 43.9366 37.9996 43.9366H55.1376C56.0746 43.9366 56.8344 43.177 56.8344 42.2398C56.8344 41.3026 56.0746 40.543 55.1376 40.543Z"
            fill="#353CEE"
        />
        <path
            d="M55.1376 49.0273H37.9996C37.0624 49.0273 36.3027 49.787 36.3027 50.7242C36.3027 51.6613 37.0624 52.421 37.9996 52.421H55.1376C56.0746 52.421 56.8344 51.6613 56.8344 50.7242C56.8344 49.787 56.0746 49.0273 55.1376 49.0273Z"
            fill="#353CEE"
        />
        <path
            d="M29.5165 49.0273H12.3785C11.4413 49.0273 10.6816 49.787 10.6816 50.7242C10.6816 51.6613 11.4413 52.421 12.3785 52.421H29.5165C30.4536 52.421 31.2133 51.6613 31.2133 50.7242C31.2133 49.787 30.4536 49.0273 29.5165 49.0273Z"
            fill="#353CEE"
        />
        <path
            d="M29.5165 23.5742H12.3785C11.4413 23.5742 10.6816 24.3339 10.6816 25.2711V42.4091C10.6816 43.3462 11.4413 44.1059 12.3785 44.1059H29.5165C30.4536 44.1059 31.2133 43.3462 31.2133 42.4091V25.2711C31.2133 24.3339 30.4536 23.5742 29.5165 23.5742ZM27.8197 40.7122H14.0753V26.9679H27.8197V40.7122Z"
            fill="#353CEE"
        />
        <path
            d="M72.1063 13.3943H67.0158V8.30382C67.0158 6.43255 65.4934 4.91016 63.6222 4.91016H3.89367C2.0224 4.91016 0.5 6.43255 0.5 8.30382V62.6025C0.5 67.2806 4.306 71.0866 8.98416 71.0866H67.0158C71.694 71.0866 75.5 67.2806 75.5 62.6025V16.788C75.5 14.9167 73.9776 13.3943 72.1063 13.3943ZM72.1063 62.6025C72.1063 65.4094 69.8227 67.693 67.0158 67.693H8.98416C6.17726 67.693 3.89367 65.4094 3.89367 62.6025V8.30382H63.6222V60.0572C63.6222 62.3963 65.5252 64.2993 67.8643 64.2993C68.8012 64.2993 69.5611 63.5396 69.5611 62.6025C69.5611 61.6653 68.8012 60.9056 67.8643 60.9056C67.3964 60.9056 67.0158 60.525 67.0158 60.0572V16.788H72.1063V62.6025Z"
            fill="#353CEE"
        />
    </g>
    <defs>
        <clipPath id="clip0_1104_2708">
            <rect width="100%" height="100%" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
    </defs>
</template>
